"use strict";

var _regeneratorRuntime = require("/codebuild/output/src411074015/src/code-for-humans-private/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src411074015/src/code-for-humans-private/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src411074015/src/code-for-humans-private/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src411074015/src/code-for-humans-private/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/esnext.promise.all-settled.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextDrawer = exports.validTypes = void 0;

var Utils_1 = require("../../Utils");

exports.validTypes = ["text", "character", "char"];

var TextDrawer = /*#__PURE__*/function () {
  function TextDrawer() {
    _classCallCheck(this, TextDrawer);
  }

  _createClass(TextDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 12;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(container) {
        var options, shapeOptions, promises, _iterator, _step, character;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = container.actualOptions;

                if (!exports.validTypes.find(function (t) {
                  return (0, Utils_1.isInArray)(t, options.particles.shape.type);
                })) {
                  _context.next = 14;
                  break;
                }

                shapeOptions = exports.validTypes.map(function (t) {
                  return options.particles.shape.options[t];
                }).find(function (t) {
                  return !!t;
                });

                if (!(shapeOptions instanceof Array)) {
                  _context.next = 11;
                  break;
                }

                promises = [];
                _iterator = _createForOfIteratorHelper(shapeOptions);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    character = _step.value;
                    promises.push((0, Utils_1.loadFont)(character));
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                _context.next = 9;
                return Promise.allSettled(promises);

              case 9:
                _context.next = 14;
                break;

              case 11:
                if (!(shapeOptions !== undefined)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 14;
                return (0, Utils_1.loadFont)(shapeOptions);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init(_x) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "draw",
    value: function draw(context, particle, radius, opacity) {
      var _a, _b, _c;

      var character = particle.shapeData;

      if (character === undefined) {
        return;
      }

      var textData = character.value;

      if (textData === undefined) {
        return;
      }

      var textParticle = particle;

      if (textParticle.text === undefined) {
        textParticle.text = textData instanceof Array ? (0, Utils_1.itemFromArray)(textData, particle.randomIndexData) : textData;
      }

      var text = textParticle.text;
      var style = (_a = character.style) !== null && _a !== void 0 ? _a : "";
      var weight = (_b = character.weight) !== null && _b !== void 0 ? _b : "400";
      var size = Math.round(radius) * 2;
      var font = (_c = character.font) !== null && _c !== void 0 ? _c : "Verdana";
      var fill = particle.fill;
      var offsetX = text.length * radius / 2;
      context.font = "".concat(style, " ").concat(weight, " ").concat(size, "px \"").concat(font, "\"");
      var pos = {
        x: -offsetX,
        y: radius / 2
      };
      context.globalAlpha = opacity;

      if (fill) {
        context.fillText(text, pos.x, pos.y);
      } else {
        context.strokeText(text, pos.x, pos.y);
      }

      context.globalAlpha = 1;
    }
  }]);

  return TextDrawer;
}();

exports.TextDrawer = TextDrawer;